import axios from 'axios'
import { toast } from 'react-toastify'
import {
  AllOrderDetails,
  CustomerStatusUpdate,
  ORDER_STATUS
} from 'components/common/types'

import {
  ALL_ORDER_DETAILS_REQUEST,
  ALL_ORDER_DETAILS_SUCCESS,
  ALL_ORDER_DETAILS_FAILURE,
  SINGLE_ORDER_DETAILS_REQUEST,
  SINGLE_ORDER_DETAILS_SUCCESS,
  SINGLE_ORDER_DETAILS_FAILURE,
  UPDATE_ALL_ORDERS_FROM_SIGNALR,
  FETCH_ORDER_LIST_BY_BUTTON_REQUEST,
  FETCH_ORDER_LIST_BY_BUTTON_SUCCESS,
  FETCH_ORDER_LIST_BY_BUTTON_FAILURE
} from '../constants'
import { TypedThunk } from 'reducers'
import { noticeError } from 'components/common/newRelicBrowser'

export const convertOrderList = (data) => (dispatch, getState) => {
  const editedPendingOrders: AllOrderDetails[] = data.pending.map(
    (pendingOrder) => {
      const centeredPoi = pendingOrder.pois.find((poi) => poi.UsedToCenterMap)

      return {
        ...pendingOrder,
        pois: pendingOrder.pois.filter(
          (poi) =>
            poi.Lat !== null &&
            poi.Lng !== null &&
            poi.Lat !== '' &&
            poi.Lng !== ''
        ),
        centeredPoi,
        stageStatus: pendingOrder.status,
        orderStatus: ORDER_STATUS.PENDING
        // delivery_address: 'test123'
      }
    }
  )

  const editedCompletedOrders: AllOrderDetails[] = data.completed.map(
    (completedOrder) => {
      const centeredPoi = completedOrder.pois.find((poi) => poi.UsedToCenterMap)

      return {
        ...completedOrder,
        pois: completedOrder.pois.filter(
          (poi) =>
            poi.Lat !== null &&
            poi.Lng !== null &&
            poi.Lat !== '' &&
            poi.Lng !== ''
        ),
        centeredPoi,
        stageStatus: completedOrder.status,
        orderStatus: ORDER_STATUS.COMPLETED
      }
    }
  )

  return {
    pending: editedPendingOrders,
    completed: editedCompletedOrders
  }
}

export const fetchOrdersByButton =
  (): TypedThunk<
    Promise<{
      pending: AllOrderDetails[]
      completed: AllOrderDetails[]
    }>
  > =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: FETCH_ORDER_LIST_BY_BUTTON_REQUEST
      })

      const { data } = await axios.get(`/user/orders`)

      const mergedOrders = dispatch(convertOrderList(data))

      dispatch({
        type: FETCH_ORDER_LIST_BY_BUTTON_SUCCESS,
        payload: mergedOrders
      })

      return mergedOrders
    } catch (error) {
      const errorMessage =
        error?.response?.data?.ExceptionMessage || 'The request is invalid.'

      toast.error(errorMessage, { autoClose: 6000 })

      dispatch({
        type: FETCH_ORDER_LIST_BY_BUTTON_FAILURE,
        payload: errorMessage
      })

      return Promise.reject()
    }
  }

export const allOrderDetails =
  (): TypedThunk<
    Promise<{
      pending: AllOrderDetails[]
      completed: AllOrderDetails[]
    }>
  > =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: ALL_ORDER_DETAILS_REQUEST
      })

      const { data } = await axios.get(`/user/orders`)

      const mergedOrders = dispatch(convertOrderList(data))

      dispatch({
        type: ALL_ORDER_DETAILS_SUCCESS,
        payload: mergedOrders
      })

      return mergedOrders
    } catch (error) {
      const errorMessage =
        error?.response?.data?.ExceptionMessage || 'The request is invalid.'

      toast.error(errorMessage, { autoClose: 6000 })

      dispatch({
        type: ALL_ORDER_DETAILS_FAILURE,
        payload: errorMessage
      })

      return Promise.reject()
    }
  }

export const singleOrderDetails = (orderId) => async (dispatch, getState) => {
  try {
    dispatch({
      type: SINGLE_ORDER_DETAILS_REQUEST
    })

    const { data } = await axios.get(`/user/orders/${orderId}`)

    dispatch({
      type: SINGLE_ORDER_DETAILS_SUCCESS,
      payload: data
    })
  } catch (error) {
    const errorMessage =
      error?.response?.data?.ExceptionMessage || 'The request is invalid.'

    toast.error(errorMessage, { autoClose: 6000 })

    dispatch({
      type: SINGLE_ORDER_DETAILS_FAILURE,
      payload: errorMessage
    })
  }
}

export const listenCustomerStatusUpdate =
  (socketOrder: CustomerStatusUpdate): TypedThunk =>
  async (dispatch, getState) => {
    const allOrders = getState().orderDetails.allOrders

    const foundStatus = socketOrder.Stages.find(
      (stage) => stage.StatusId === socketOrder.StageId
    )

    noticeError('ORDER_STATUS_UPDATE', {
      is_completed: socketOrder.Completed,
      is_rejected: socketOrder.Rejected,
      stageStatus: socketOrder.StageId,
      completion_estimate: socketOrder.OrderCompletionEstimate,
      stageName: foundStatus?.StageName
    })

    dispatch({
      type: UPDATE_ALL_ORDERS_FROM_SIGNALR,
      payload: allOrders.data?.pending?.map((order) => {
        if (order.id === socketOrder.OrderNumber) {
          return {
            ...order,
            stages: socketOrder.Stages,
            is_completed: socketOrder.Completed,
            is_rejected: socketOrder.Rejected,
            stageStatus: socketOrder.StageId,
            completion_estimate: socketOrder.OrderCompletionEstimate
          }
        }

        return order
      })
    })
  }
